import {popperVariation, TippyConfig, tooltipVariation} from "@ngneat/helipopper/config"

// Append inside the CDK overlay popover wrapper when inside a CDK overlay (e.g. dialogs),
// because CDK v21 renders overlays in the browser's top layer via the Popover API.
// Tooltips appended to document.body would be hidden behind the top layer.
export const cmTooltipAppendTo = (reference: Element): HTMLElement => (reference.closest(".cdk-overlay-popover") as HTMLElement) ?? document.body

export const cmTippyConfig: Partial<TippyConfig> = {
    appendTo: cmTooltipAppendTo,
    defaultVariation: "tooltip",
    variations: {
        light: {...tooltipVariation, theme: "light", animation: "scale-subtle", delay: [200, 0], placement: "top"},
        tooltip: {...tooltipVariation, theme: "colormass-tooltip", animation: "scale-subtle"},
        popper: {...popperVariation, theme: "colormass-popover", arrow: false},
    },
}
